let url = $(location).attr('href').split("/").splice(0, 5).join("/");
let segments = url.split('/');
let lang = segments[3];
let two_segment = segments[4];
if ('' === lang) {
    lang = 'ro';
}

$(document).ready(function () {
    $(document).on("click", ".add_to_favorite, .delete_favorite", function (event) {
        event.preventDefault();
        const _self = $(this);
        const box = _self.closest('.bv_data');
        const id = box.data('id');

        $.post('/' + lang + '/ajax/add_to_favorite', {id: id}, function (result) {
            let data = JSON.parse(result);
            if (data.action === 'add') {
                _self.addClass('_liked');
            } else {
                _self.removeClass('_liked');
                if (_self.hasClass('delete_favorite')) {
                    window.location.reload();
                }
            }
            $(".favorite_count").text(data.count);
        });
    });
});
